// Helpers for onboarding welcome hero (media + hex sanitization)

/** @param {unknown} v */
export function sanitizeHexColor(v) {
  const s = String(v || '').trim();
  if (/^#[0-9a-fA-F]{6}$/.test(s)) return s.toLowerCase();
  return '';
}

/**
 * @param {{ mediaType?: string|null, url?: string|null }|null|undefined} media
 * @returns {'none'|'image'|'hls'|'video'}
 */
export function onboardingBackgroundKind(media) {
  const url = media?.url ? String(media.url).trim() : '';
  if (!url) return 'none';

  const mt = String(media?.mediaType || '').toLowerCase();
  if (mt.startsWith('image/')) return 'image';
  if (mt === 'video/hls' || mt === 'application/vnd.apple.mpegurl' || mt === 'application/x-mpegurl') {
    return 'hls';
  }
  try {
    const parsed = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    if (parsed.pathname.toLowerCase().endsWith('.m3u8')) return 'hls';
  } catch {
    if (String(url).toLowerCase().split('?')[0].endsWith('.m3u8')) return 'hls';
  }
  if (mt.startsWith('video/')) return 'video';
  return 'none';
}

/**
 * Total dwell duration in seconds from onboarding element `payload` (admin minimum time).
 * @param {unknown} payload
 * @returns {number} 0 if disabled or invalid
 */
export function getMinimumDwellTotalSeconds(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return 0;
  if (!payload.minimumDwellEnabled) return 0;
  const m = Math.max(0, Math.min(599, parseInt(payload.minimumDwellMinutes, 10) || 0));
  const s = Math.max(0, Math.min(59, parseInt(payload.minimumDwellSeconds, 10) || 0));
  const total = m * 60 + s;
  return total < 1 ? 0 : Math.min(total, 599 * 60 + 59);
}
